import { render, staticRenderFns } from "./addFile.vue?vue&type=template&id=90b8be3c&scoped=true&"
import script from "./addFile.vue?vue&type=script&lang=js&"
export * from "./addFile.vue?vue&type=script&lang=js&"
import style0 from "./addFile.vue?vue&type=style&index=0&id=90b8be3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b8be3c",
  null
  
)

export default component.exports